import {
  HttpEvent, HttpHandler, HttpInterceptor,
  HttpRequest, HttpResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AlertService } from "src/app/main/alert.service";

@Injectable()
export class SuccessInterceptor implements HttpInterceptor {
  constructor(private router: Router, private toastr: AlertService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (
            event.status == 200 &&
            req.method != "GET" &&
            !req.url.includes("login") &&
            !req.url.includes("logout") &&
            !req.url.includes('/planprofiles/conflicts/check') &&
            !req.url.includes("lastLogValue") &&
            !(req.method == "PUT" && req.url.includes("crm/customers"))
          ) {
            if (event.body != null && event.body.name) {
              switch (req.method) {
                case "POST":
                  this.toastr.success(
                    String(event.body.name) + " added successfully "
                  );
                  break;
                case "PUT":
                  this.toastr.success(
                    String(event.body.name) + " updated successfully"
                  );
                  break;
                case "DELETE":
                  this.toastr.success(
                    String(event.body.name) + " deleted successfully"
                  );
                  break;
                default:
                  break;
              }
            } else {
              this.toastr.success("Action completed successfully");
            }
          }
        }
      })
    );
  }
}
